import React from "react";
import rigbyHead from "../rigby-head.png";
import { initials, formatClock } from "../ui/text";

// Slim header: Rigby, a calm status line, History (signed-in only) and the avatar that opens the menu.
export default function ChatHeader({ userName, avatarUrl, isGuest, guestSecondsLeft, menuOpen, onOpenHistory, onOpenMenu }) {
  const showTimer = isGuest && guestSecondsLeft !== null && guestSecondsLeft !== undefined;
  return (
    <header className="rg-header">
      <img className="rg-mark" src={rigbyHead} alt="" />
      <div className="rg-header-text">
        <h1 className="rg-title">Rigby</h1>
        <p className="rg-status">
          <span className="rg-live" aria-hidden="true" />
          {isGuest ? "guest demo" : "here with you"}
        </p>
      </div>
      <div className="rg-grow" />
      {showTimer && (
        <span className={`rg-pill${guestSecondsLeft <= 60 ? " is-warn" : ""}`} aria-live="off">
          {formatClock(guestSecondsLeft)} left
        </span>
      )}
      {!isGuest && (
        <button type="button" className="rg-btn-pill" onClick={onOpenHistory}>
          History
        </button>
      )}
      <button
        type="button"
        className="rg-avatar-btn"
        aria-label="Open menu"
        aria-haspopup="menu"
        aria-expanded={!!menuOpen}
        onClick={onOpenMenu}
      >
        {avatarUrl ? <img src={avatarUrl} alt="" /> : initials(userName)}
      </button>
    </header>
  );
}
